import WistiaPlayer from "components/WistiaPlayer/WistiaPlayer";
import React from "react";

const videos = [
  {
    id: "tgklw82ryh",
    title: "Getting started with VT Docs",
    url: "https://fast.wistia.net/embed/iframe/tgklw82ryh",
  },
  {
    id: "94cyev7jk7",
    title: "Simple Shred (Compliance Matrix)",
    url: "https://fast.wistia.net/embed/iframe/94cyev7jk7",
  },
  {
    id: "qg16tnacdu",
    title: "Category Shred",
    url: "https://fast.wistia.net/embed/iframe/qg16tnacdu",
  },
  {
    id: "5ed4q6lg3z",
    title: "Dictionary Search",
    url: "https://fast.wistia.net/embed/iframe/5ed4q6lg3z",
  },
  {
    id: "ubxgknih2j",
    title: "Using the Compare Docs Feature",
    url: "https://fast.wistia.net/embed/iframe/ubxgknih2j",
  },
  {
    id: "bluaxtqsau",
    title: "Extract Acronyms",
    url: "https://fast.wistia.net/embed/iframe/bluaxtqsau",
  },
  {
    id: "iw2nheki1k",
    title: "How to Use the Discovery Tab to Identify Key Themes",
    url: "https://fast.wistia.net/embed/iframe/iw2nheki1k",
  },
  {
    id: "zcdzpg97rh",
    title: "What are Dictionaries in VT Docs?",
    url: "https://fast.wistia.net/embed/iframe/zcdzpg97rh",
  },
];

const HelpVideos = () => (
  <>
    <h2>Video Guides</h2>
    <section className="help__video_guides">
      {videos.map((video) => (
        <WistiaPlayer
          videoId={video.id}
          title={video.title}
          url={video.url}
          popover
        />
      ))}
    </section>
    <section className="help__more_videos">
      <a
        href="https://www.visiblethread.com/product-videos/#vt-docs"
        className="vt_button primary"
        target="_blank"
        rel="noreferrer"
      >
        More Videos
      </a>
    </section>
  </>
);

export default HelpVideos;
